import styled from "styled-components";
import { Text } from "components";
import { Img } from "components";

export const StyledFooterText = styled(Text)`
  color: ${({ theme }) =>
    theme.colors[theme.textColors.secondary.color][
      theme.textColors.secondary.intensity
    ]};
`;

export const StyledImg = styled(Img)``;
